import React from 'react';
import { isPlaceholderFisico, labelsFisicos } from '../../utils/setor';

// Mapeia origem_tipo do backend ('proprio' | 'cliente' | 'fornecedor')
// para o label do badge no relatório impresso.
const BADGE_CONFIG = {
  proprio:    { label: 'NC INTERNA',                     color: '#10B981', bg: '#D1FAE5' },
  cliente:    { label: 'NC RECEBIDA DE CLIENTE',         color: '#D97706', bg: '#FEF3C7' },
  fornecedor: { label: 'NC EMITIDA PARA FORNECEDOR',     color: '#2563EB', bg: '#DBEAFE' },
};

export default function PrintableHeader({ reportData, qrDataUrl }) {
  const dados = reportData?.dados_basicos || {};
  const empresa = reportData?.empresa || {};
  const origemTipo = reportData?.origem?.origem_tipo || 'proprio';
  const badge = BADGE_CONFIG[origemTipo] || BADGE_CONFIG.proprio;
  const ncNumber = dados.numero_nc || `NC-${dados.nc_id || ''}`;
  const clienteNome = empresa.nome_fantasia || empresa.razao_social || '—';
  const lote = dados.lote || '—';
  const produto = dados.produto || '—';
  // #264 — em setor de SERVIÇO, omite Lote/Produto físicos vazios da linha de
  // metadados (num serviço não há lote/produto a exibir). Industrial: inalterado.
  const mostrarLote = !(dados.is_servico && isPlaceholderFisico(dados.lote));
  const mostrarProduto = !(dados.is_servico && isPlaceholderFisico(dados.produto));
  // #264b — quando PREENCHIDOS num serviço, renomeia os rótulos
  // (Serviço / Processo · Período / Referência), strings centralizadas em setor.js.
  const rotulosFis = labelsFisicos(dados.is_servico);

  return (
    <header className="printable-header">
      <div className="header-row">
        <div className="header-left">
          <img
            src="/qaasa-texto-dark.png"
            alt="Qaa.sa"
            className="header-logo"
          />
          <div className="header-tagline">Quality as a Service, Powered by AI</div>
        </div>
        <div className="header-right">
          <a
            href="https://qaasa.com.br"
            target="_blank"
            rel="noopener noreferrer"
            className="header-url"
          >
            qaasa.com.br
          </a>
        </div>
      </div>

      <div className="header-divider"></div>

      <div className="header-meta">
        <div className="meta-left">
          <span
            className="nc-type-badge"
            style={{ backgroundColor: badge.bg, color: badge.color }}
          >
            {badge.label}
          </span>
          <h1 className="nc-number">{ncNumber}</h1>
          <div className="nc-info">
            Tenant Emissor: <strong>{clienteNome}</strong>
            {mostrarLote && <> · {rotulosFis.lote}: <strong>{lote}</strong></>}
            {mostrarProduto && <> · {rotulosFis.produto}: <strong>{produto}</strong></>}
          </div>
          {origemTipo === 'cliente' && reportData?.origem?.cliente_emissor && (
            <div className="nc-info nc-info-secondary">
              Cliente Reclamante: <strong>{reportData.origem.cliente_emissor}</strong>
            </div>
          )}
        </div>
        <div className="meta-right">
          {qrDataUrl && (
            <div className="qr-block">
              <img src={qrDataUrl} alt="QR Code" className="qr-code" />
              <div className="qr-label">Acessar NC</div>
            </div>
          )}
        </div>
      </div>

      <div className="header-divider-thin"></div>
    </header>
  );
}
